export const effects = {
  gradient: {
    primary: 'bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-500',
    secondary: 'bg-gradient-to-r from-cyan-300 via-blue-300 to-cyan-400',
    surface: 'bg-gradient-to-b from-gray-800/95 to-gray-900/95',
    button: 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 hover:from-cyan-500/30 hover:to-blue-500/30',
    accent: 'bg-gradient-to-r from-indigo-400/20 to-blue-500/20',
    glow: 'bg-gradient-radial from-cyan-500/10 to-transparent',
    overlay: 'bg-gradient-to-t from-gray-900/95 to-gray-900/50',
    header: {
      title1: 'bg-gradient-to-r from-cyan-300 via-blue-400 to-cyan-400',
      title2: 'bg-gradient-to-r from-blue-300 via-cyan-300 to-blue-400',
    },
    text: {
      primary: 'bg-gradient-to-r from-cyan-300 via-blue-400 to-cyan-400 text-transparent bg-clip-text',
      secondary: 'bg-gradient-to-r from-blue-300 via-cyan-300 to-blue-400 text-transparent bg-clip-text'
    }
  },
  blur: {
    sm: 'backdrop-blur-sm',
    md: 'backdrop-blur-md',
    lg: 'backdrop-blur-lg'
  },
  glow: {
    sm: 'drop-shadow-[0_0_3px_rgba(34,211,238,0.3)]',
    md: 'drop-shadow-[0_0_5px_rgba(34,211,238,0.5)]',
    lg: 'drop-shadow-[0_0_8px_rgba(34,211,238,0.7)]'
  },
  animation: {
    hover: 'transition-all duration-300',
    pulse: 'animate-pulse',
    spin: 'animate-spin',
    bounce: 'animate-bounce'
  }
} 